import $ from 'jquery';

$(function () {
	// ── Service Worker Registration ──
	if ('serviceWorker' in navigator) {
		navigator.serviceWorker.register('/sw.js').catch(function () { });
	}

	var deferredPrompt = null;
	var PWA_DISMISS_KEY = 'pwa_install_dismissed';
	var PWA_INSTALLED_KEY = 'pwa_installed';

	// Don't show if already installed or running as standalone
	function isStandalone() {
		return window.matchMedia('(display-mode: standalone)').matches
			|| window.navigator.standalone === true;
	}

	function wasDismissed() {
		var dismissed = localStorage.getItem(PWA_DISMISS_KEY);
		if (!dismissed) return false;
		// Allow re-prompt after 7 days
		return (Date.now() - parseInt(dismissed, 10)) < 7 * 24 * 60 * 60 * 1000;
	}

	function isInstalled() {
		return localStorage.getItem(PWA_INSTALLED_KEY) === '1';
	}

	// ── Detect platform ──
	function getDeviceType() {
		var ua = navigator.userAgent || '';
		if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
		if (/android/i.test(ua)) return 'android';
		return 'desktop';
	}

	function showInstallModal() {
		var device = getDeviceType();
		var $modal = $('#pwaInstallModal');

		// Show/hide platform-specific instructions
		$modal.find('.pwa-instructions').hide();
		$modal.find('.pwa-instructions-' + device).show();

		// Show native install button only on Android/Desktop (where beforeinstallprompt works)
		if (deferredPrompt) {
			$modal.find('.pwa-native-install').show();
		} else {
			$modal.find('.pwa-native-install').hide();
		}

		bootstrap.Modal.getOrCreateInstance($modal[0]).show();
	}

	// ── Android & Desktop: capture beforeinstallprompt ──
	window.addEventListener('beforeinstallprompt', function (e) {
		e.preventDefault();
		deferredPrompt = e;

		if (!isStandalone() && !wasDismissed() && !isInstalled()) {
			// Small delay so the page has time to render
			setTimeout(function () {
				showInstallModal();
			}, 1000);
		}
	});

	// ── iOS: show modal after delay (no beforeinstallprompt on Safari) ──
	if (getDeviceType() === 'ios' && !isStandalone() && !wasDismissed() && !isInstalled()) {
		setTimeout(function () {
			showInstallModal();
		}, 1000);
	}

	// ── Native install button click ──
	$(document).on('click', '#pwaInstallBtn', function () {
		if (!deferredPrompt) return;

		deferredPrompt.prompt();
		deferredPrompt.userChoice.then(function (choiceResult) {
			if (choiceResult.outcome === 'accepted') {
				localStorage.setItem(PWA_INSTALLED_KEY, '1');
			}
			deferredPrompt = null;
			bootstrap.Modal.getOrCreateInstance(document.getElementById('pwaInstallModal')).hide();
		});
	});

	// ── Dismiss: remember for 7 days ──
	$(document).on('click', '#pwaInstallDismiss', function () {
		localStorage.setItem(PWA_DISMISS_KEY, Date.now().toString());
		bootstrap.Modal.getOrCreateInstance(document.getElementById('pwaInstallModal')).hide();
	});

	// ── Manual trigger (e.g., from a menu link) ──
	$(document).on('click', '.pwa-install-trigger', function (e) {
		e.preventDefault();
		showInstallModal();
	});

	// ── Detect successful install ──
	window.addEventListener('appinstalled', function () {
		localStorage.setItem(PWA_INSTALLED_KEY, '1');
		deferredPrompt = null;
	});
});
